export const SUPPORTED_LOCALES = ['en', 'bg', 'de']

function cleanPathname(pathname) {
  return pathname.replace(/index\.html$/i, '')
}

export function getLocaleUrls() {
  const current = new URL(window.location.href)
  current.hash = ''
  current.search = ''

  const cleanPath = cleanPathname(current.pathname)
  const languageMatch = cleanPath.match(/^(.*?)(?:bg|de)\/$/i)
  const basePath = languageMatch?.[1] ?? cleanPath
  const base = new URL(current)
  base.pathname = basePath.endsWith('/') ? basePath : `${basePath}/`
  const isLocalFile = current.protocol === 'file:'

  return {
    base: base.href,
    en: new URL(isLocalFile ? 'index.html' : './', base).href,
    bg: new URL(isLocalFile ? 'bg/index.html' : 'bg/', base).href,
    de: new URL(isLocalFile ? 'de/index.html' : 'de/', base).href,
    image: new URL('measurement-hero.png', base).href,
  }
}

export function detectLocale() {
  const declaredLocale = document.documentElement.lang.toLowerCase().split('-')[0]
  if (SUPPORTED_LOCALES.includes(declaredLocale)) return declaredLocale

  const pathLocale = cleanPathname(window.location.pathname).match(/\/(bg|de)\/$/i)?.[1]?.toLowerCase()
  return SUPPORTED_LOCALES.includes(pathLocale) ? pathLocale : 'en'
}
